module.exports = __webpack_public_path__ + "static/media/statsweb.c5cfdd9d.webp";